import React from 'react'

export default function SmartPhone() {
    return (
        <div>
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_301_3112)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M28.2562 50H4.16667C1.86667 50 0 48.1333 0 45.8333V4.16667C0 1.86667 1.86667 0 4.16667 0H33.3333C35.6333 0 37.5 1.86667 37.5 4.16667V12.5H33.3333V6.25H4.16667V41.6667H27.0833V46.875C27.0833 47.9667 27.4625 49.3229 28.2562 50ZM46.875 14.5833C48.6 14.5833 50 15.9833 50 17.7083V46.875C50 48.5958 48.6021 50 46.875 50H32.2917C30.5646 50 29.1667 48.5938 29.1667 46.875V17.7083C29.1667 15.9854 30.5687 14.5833 32.2917 14.5833H46.875ZM18.75 43.75C19.9 43.75 20.8333 44.6833 20.8333 45.8333C20.8333 46.9833 19.9 47.9167 18.75 47.9167C17.6 47.9167 16.6667 46.9833 16.6667 45.8333C16.6667 44.6833 17.6 43.75 18.75 43.75ZM39.5833 47.9167C38.4312 47.9167 37.5 46.9833 37.5 45.8333C37.5 44.6833 38.4312 43.75 39.5833 43.75C40.7333 43.75 41.6646 44.6833 41.6646 45.8333C41.6646 46.9833 40.7333 47.9167 39.5833 47.9167ZM47.9167 41.6667V20.7833H31.25V41.6667H47.9167ZM40.625 18.75C41.1979 18.75 41.6667 18.2833 41.6667 17.7083C41.6667 17.1333 41.1979 16.6667 40.625 16.6667H38.5417C37.9667 16.6667 37.5 17.1333 37.5 17.7083C37.5 18.2833 37.9667 18.75 38.5417 18.75H40.625Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_301_3112">
                        <rect width="50" height="50" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
